export function formatHash(hash?: string | null, startChars = 8, endChars = 8): string {
  if (typeof hash !== 'string' || !hash) return '—'
  if (hash.length <= startChars + endChars + 3) return hash
  return `${hash.slice(0, startChars)}...${hash.slice(-endChars)}`
}

export function formatId(id?: string | null, length = 8): string {
  if (typeof id !== 'string' || !id) return '—'
  if (id.length <= length) return id
  return `${id.slice(0, length)}...`
}
